import { defineStore } from "pinia";
import { computed } from "vue";
import { pickBy } from "lodash-es";
import { useSceneNodesStore } from "../scene/sceneNodes.store";
import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { Subset } from "@/helpers/utility/Type";
import type { SceneGroupData } from "./sceneGroupData";

export const useSceneGroupStore = defineStore("model/sceneGroups", () => {
  const sceneNodeStore = useSceneNodesStore();

  function isGroupItem(item: SceneNodeItem): item is SceneNodeItem<"group"> {
    return item.dataType === "group";
  }

  async function create(options: Subset<SceneNodeItem<"group">> & { dataType: "group", data: SceneGroupData }) {
    return await sceneNodeStore.create(options);
  }

  const items = computed(() => {
    return pickBy(sceneNodeStore.items, isGroupItem) as Record<number, SceneNodeItem<"group">>;
  });

  const byUid = computed(() => {
    return pickBy(sceneNodeStore.byUid, isGroupItem) as Record<string, SceneNodeItem<"group">>;
  });

  function $reset() {
    // handled by sceneNodeStore.
    return;
  }

  return {
    create,
    items,
    byUid,
    $reset
  }
});
